import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAlert = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M8.01242 1.9375C5.80575 1.9375 4.01242 3.73083 4.01242 5.9375V7.86417C4.01242 8.27083 3.83908 8.89083 3.63242 9.2375L2.86575 10.5108C2.39242 11.2975 2.71908 12.1708 3.58575 12.4642C6.45908 13.4242 9.55908 13.4242 12.4324 12.4642C13.2391 12.1975 13.5924 11.2442 13.1524 10.5108L12.3857 9.2375C12.1857 8.89083 12.0124 8.27083 12.0124 7.86417V5.9375C12.0124 3.7375 10.2124 1.9375 8.01242 1.9375Z",
			fill: "white",
			stroke: "#FC8210",
			strokeWidth: 1.5,
			strokeMiterlimit: 10,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.24792 2.13297C9.04125 2.07297 8.82792 2.0263 8.60792 1.99964C7.96792 1.91964 7.35458 1.9663 6.78125 2.13297C6.97458 1.63964 7.45458 1.29297 8.01458 1.29297C8.57458 1.29297 9.05458 1.63964 9.24792 2.13297Z",
			fill: "white",
			stroke: "#FC8210",
			strokeWidth: 1.5,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.0156 12.707C10.0156 13.807 9.11562 14.707 8.01562 14.707C7.46896 14.707 6.96229 14.4804 6.60229 14.1204C6.24229 13.7604 6.01562 13.2537 6.01562 12.707",
			stroke: "#FC8210",
			strokeMiterlimit: 10
		})
	]
});
export default SvgAlert;
